module.exports = "/images/Make marketing easier and faster.svg?c37adf9190a1463e396686d1eb62c52b";